module.exports = __webpack_public_path__ + "static/media/Down_Arrow_Black.1c2723e5.svg";